import { useSyncExternalStore } from 'react';
import { getWaitingListId, subscribeWaitingListIdChange } from '../utils/waitingRoom/session';

/**
 * Реактивный доступ к waitingListId. sessionStorage — единственный источник истины;
 * подписка через subscribeWaitingListIdChange, snapshot — getWaitingListId.
 */
export const useWaitingListId = (): string | undefined =>
    useSyncExternalStore(subscribeWaitingListIdChange, getWaitingListId);
